/* eslint-disable import/no-unresolved */
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// MENU
const WelcomePage = lazy(() => import('src/pages/dashboard/welcome'));
const SettingsPage = lazy(() => import('src/pages/settings/settings'));
const Users = lazy(() => import('src/pages/users/list'));
const Building = lazy(() => import('src/pages/building/list'));
const BuildingDetails = lazy(() => import('src/pages/building/details'));
const Organization = lazy(() => import('src/pages/organization/list'));
const OrganizationDetails = lazy(() => import('src/pages/organization/details'));
const UnitDetailsPage = lazy(() => import('src/pages/building/units/details'));
const BuildingBillableServiceDetailsPage = lazy(() => import('src/pages/building/billableServices/details'));
const UnitBillableServiceDetailsPage = lazy(() => import('src/pages/building/units/billableServices/details'));
const BuildingBankAccountDetailsPage = lazy(() => import('src/pages/building/bankAccounts/details'));
const BuildingFundDetailsPage = lazy(() => import('src/pages/building/funds/details'));
const InvoiceListPage = lazy(() => import('src/pages/invoice/list'));
const BankStatementListPage = lazy(() => import('src/pages/bankStatement/list'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <WelcomePage />, index: true },
      { path: 'dashboard', element: <WelcomePage /> },
    ],
  },

  {
    path: 'settings',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <SettingsPage />, index: true },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },

  {
    path: 'users',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <Users />, index: true },
      { path: 'users', element: <Users /> },
    ],
  },

  {
    path: 'building',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <Building />, index: true },
      { path: ':id', element: <BuildingDetails /> },
      { path: ':building_id/units/:id', element: <UnitDetailsPage /> },
      { path: ':building_id/billable-services/:id', element: <BuildingBillableServiceDetailsPage /> },
      { path: ':building_id/units/:unit_id/billable-services/:id', element: <UnitBillableServiceDetailsPage /> },
      { path: ':building_id/bank-accounts/:id', element: <BuildingBankAccountDetailsPage /> },
      { path: ':building_id/funds/:id', element: <BuildingFundDetailsPage /> },
    ],
  },


  {
    path: 'invoice',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <InvoiceListPage />, index: true },
    ],
  },

  {
    path: 'bank-statement',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <BankStatementListPage />, index: true },
    ],
  },

  {
    path: 'organization',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <Organization />, index: true },
      { path: ':id', element: <OrganizationDetails /> },
    ],
  },

];
